<template>
  <div class="party" v-if="show">
    <div class="big" v-if="showBig">
      <div class="big-in">
        <el-button icon="el-icon-close" size="small" circle @click="close('big')"></el-button>
        <img
          src="https://download.zhidiancloud.com/zd/images/20240115/1705283232767.png"
          @click="routeTo('big')"
          alt=""
        />
      </div>
    </div>
    <div class="small" v-if="!showBig && showSmall">
      <el-button icon="el-icon-close" size="mini" circle @click="close('small')"></el-button>
      <img
        src="https://download.zhidiancloud.com/zd/images/20240115/1705283232767.png"
        @click="routeTo('small')"
        alt=""
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import * as hinaApi from '@/utils/hina';
const show = ref(false);
const showBig = ref(true);
const showSmall = ref(true);
const option = ref({
  domain: import.meta.env.VITE_APP_ENV === 'development' ? '.testdomain.com' : '.zhidiancloud.com',
  SameSite: import.meta.env.VITE_APP_ENV === 'development' ? 'lax' : 'none',
  Secure: import.meta.env.VITE_APP_ENV === 'development' ? false : true,
  expires: new Date(dayjs().format('YYYY-MM-DD') + 'T23:59:59'),
});
const url = ref(import.meta.env.VITE_APP_DOMAIN_POINT + '/packages/list');
onMounted(() => {
  if (dayjs().isAfter(dayjs('2024-02-01'))) {
    return (show.value = false);
  }
  if (
    window.location.href.replace(/^https?:\/\//i, '').replace(/\?.*$/, '') == url.value.replace(/^https?:\/\//i, '')
  ) {
    return (show.value = false);
  }
  if (Cookies.get('showed', option.value)) {
    showBig.value = false;
    showSmall.value = true;
    show.value = true;
  } else {
    showBig.value = true;
    showSmall.value = true;
    show.value = true;
  }
});
function routeTo(type) {
  hinaApi.packageActivityClickPoint();
  window.open(url.value, '_blank');
  if (type == 'big') {
    close(type);
  }
}
function close(type) {
  if (type == 'big') {
    showBig.value = false;
    Cookies.set('showed', 'true', option.value);
  } else {
    showSmall.value = false;
  }
}
</script>
<style lang="scss" scoped>
.party {
  .el-button {
    position: absolute;
    top: 0;
    right: -6px;
  }

  img {
    cursor: pointer;
  }

  .big {
    position: fixed;
    z-index: 9999999;
    width: 100%;
    height: 100vh;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.4);

    .big-in {
      // width: 320px;
      position: relative;
      img {
        max-height: 90vh;
      }
    }
  }

  .small {
    position: fixed;
    z-index: 9999999;
    right: 150px;
    width: 200px;
    margin-top: 6px;
  }
}
</style>
